import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import { ArchiveDownload } from '@/scenes/User/Settings/Blog/ArchiveDownload';
import { ArchiveUpload } from '@/scenes/User/Settings/Blog/ArchiveUpload/ArchiveUpload';

export function ArchiveSettings() {
  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Архив</h4>
          <p>
            Здесь можно загрузить архив дневника на Дыбр или получить архив
            своего блога.
          </p>
        </SettingSectionTitle>

        <Settings>
          <ArchiveUpload />
          <ArchiveDownload />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
